import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { PageHeader } from "@/widgets/page-header"
import { fetchJobApplications, fetchVacancies, selectJobApplicationsFirstLoad, selectVacanciesFirstLoad } from "../model"
import { useEffect } from "react"
import { Vacancies } from "./vacancies"
import { CreateVacancy } from "./create-vacancy"
import { Applications } from "./applications"

export const EmploymentPage = () => {
    const dispatch = useAppDispatch()
    const applicationsFirstLoad = useAppSelector(selectJobApplicationsFirstLoad)
    const vacanciesFirstLoad = useAppSelector(selectVacanciesFirstLoad) 

    useEffect(() => {
        if (applicationsFirstLoad) {
            dispatch(fetchJobApplications())
        }
        if (vacanciesFirstLoad) {
            dispatch(fetchVacancies())
        }
    }, [])

    return (
        <div className="_page_container">
            <PageHeader title="Трудоустройство" />
            <div className="flexbox">
                <div className="w-full flex justify-end gap-2">
                    <div className="w-full bg-white h-[52px] rounded-full block"/>
                    <CreateVacancy/>
                </div>
                <div className="grid grid-cols-12 gap-4 auto-rows-fr">
                    <div className="col-span-12 screen:col-span-6">
                        <Vacancies />
                    </div>
                    <div className="col-span-12 screen:col-span-6">
                        <Applications />
                    </div>
                </div>
            </div>
        </div>
    )
}